import { arrayToMap } from "../util";

const list = [
  {
    key: 0,
    name: "指定なし",
    value: null,
  },
  {
    key: 1,
    name: "100cm未満",
    value: 1,
    minValue: 0,
    maxValue: 100,
  },
  {
    key: 2,
    name: "100〜200cm未満",
    value: 2,
    minValue: 100,
    maxValue: 200,
  },
  {
    key: 3,
    name: "200〜300cm未満",
    value: 3,
    minValue: 200,
    maxValue: 300,
  },
  {
    key: 4,
    name: "300cm以上",
    value: 4,
    minValue: 300,
  },
];

for (const item of list) {
  item.text = item.name;
}

export const data = {
  list: list,
  byValue: arrayToMap(list, "value"),
};



// WEBPACK FOOTER //
// ./lib/masterData/schemas/dimension.js